var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 11,
    viewBox: "0 0 25 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83428 0.898233C5.74599 0.858877 5.64818 0.84596 5.55269 0.861046C5.45721 0.876132 5.36814 0.918573 5.29628 0.983233L0.296281 5.48323C0.244069 5.53012 0.202313 5.58748 0.173729 5.65157C0.145144 5.71566 0.130371 5.78506 0.130371 5.85523C0.130371 5.92541 0.145144 5.9948 0.173729 6.05889C0.202313 6.12298 0.244069 6.18034 0.296281 6.22723L5.29628 10.7272C5.38905 10.8106 5.5096 10.8562 5.63428 10.8552C5.76689 10.8552 5.89407 10.8026 5.98783 10.7088C6.0816 10.615 6.13428 10.4878 6.13428 10.3552V1.35523C6.13404 1.25816 6.10554 1.16325 6.05227 1.0821C5.999 1.00095 5.92325 0.937063 5.83428 0.898233Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9683 0.983205C18.8964 0.918683 18.8074 0.876361 18.712 0.861356C18.6165 0.846351 18.5188 0.859305 18.4306 0.898651C18.3424 0.937998 18.2675 1.00205 18.2149 1.08308C18.1623 1.1641 18.1343 1.25861 18.1343 1.35521V10.3552C18.1343 10.4518 18.1623 10.5463 18.2149 10.6273C18.2675 10.7084 18.3424 10.7724 18.4306 10.8118C18.5188 10.8511 18.6165 10.8641 18.712 10.8491C18.8074 10.834 18.8964 10.7917 18.9683 10.7272L23.9683 6.22721C24.0205 6.18031 24.0622 6.12296 24.0908 6.05887C24.1194 5.99477 24.1342 5.92538 24.1342 5.85521C24.1342 5.78503 24.1194 5.71564 24.0908 5.65155C24.0622 5.58745 24.0205 5.5301 23.9683 5.48321L18.9683 0.983205Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1343 9.85522C14.3434 9.85522 16.1343 8.06436 16.1343 5.85522C16.1343 3.64609 14.3434 1.85522 12.1343 1.85522C9.92514 1.85522 8.13428 3.64609 8.13428 5.85522C8.13428 8.06436 9.92514 9.85522 12.1343 9.85522Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideIcon);
export default __webpack_public_path__ + "static/media/slideIcon.26498f9fcde96275e76552be74204e45.svg";
export { ForwardRef as ReactComponent };